import React, { useState, useEffect } from "react";
import "../styles/Contact.css";
import adress from "../assets/icones/adresse_1.png";
import contactBulle from "../assets/pictures/bulle_contact.png";

function Contact() {
  return (
    <div className="contactContainer" id="contact">
      <img
        className="contactBulle"
        src={contactBulle}
        alt="dessin d'une emprunte de chat géante avec un chat tigré de profil"
      />
      <div className="contactContent">
        <p className="contactText">
          Des questions ? Voici les différents points de contact !
        </p>
        <div className="contactText2 coordonnees">
          <div className="contactText2 coordonnee tel">
            <i className="fa-solid fa-phone-volume"></i>
            <p>Téléphone: 06.81.96.05.98</p>
          </div>
          <div className="contactText2 coordonnee email">
            <i className="fa-regular fa-envelope"></i>
            <p>E-mail: mf.rabin@sfr.fr</p>
          </div>
        </div>
        <div className="contactText2 adress">
          <div className="houseDiv">
            <img className="houseImg" src={adress} alt="icone maison" />
          </div>
          <p className="adressText">
            Adresse: 14 rue de la forge, 28310 Janville-en-beauce
            <br /> (lieu dit Outrouville)
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
